import { Injectable, EventEmitter } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
// tslint:disable-next-line:import-blacklist
import { Observable ,  Subject } from 'rxjs';

import { Alert, AlertType } from '../classes/alert';

@Injectable()
export class AlertService {

    private subject = new Subject<Alert>();
    private notif = new Subject<Alert>();
    private keepAfterRouteChange = false;
    public logoEvent: EventEmitter<any>;


    constructor(private router: Router) {
        // clear alert messages on route change unless 'keepAfterRouteChange' flag is true
        router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (this.keepAfterRouteChange) {
                    // only keep for a single route change
                    this.keepAfterRouteChange = false;
                } else {
                    // clear alert messages
                    this.clear();
                    this.clearNotif();
                }
            }
        });

        this.logoEvent    = new EventEmitter();
    }

    getAlert(): Observable<any> {
        return this.subject.asObservable();
    }

    getNotif(): Observable<any> {
        return this.notif.asObservable();
    }

    success(message: string, notification = false, keepAfterRouteChange = false, removedAfter = 6000) {
        if (notification) {
            this.notify(AlertType.Success, message, keepAfterRouteChange, removedAfter);
        } else {
            this.alert(AlertType.Success, message, keepAfterRouteChange, removedAfter);
        }
    }

    error(message: string, notification = false, keepAfterRouteChange = false, removedAfter = 6000) {
        if (notification) {
            this.notify(AlertType.Error, message, keepAfterRouteChange, removedAfter);
        } else {
            this.alert(AlertType.Error, message, keepAfterRouteChange, removedAfter);
        }
    }

    info(message: string, notification = false, keepAfterRouteChange = false, removedAfter = 6000) {
        if (notification) {
            this.notify(AlertType.Info, message, keepAfterRouteChange, removedAfter);
        } else {
            this.alert(AlertType.Info, message, keepAfterRouteChange, removedAfter);
        }
    }

    warn(message: string, notification = false, keepAfterRouteChange = false, removedAfter = 6000) {
        if (notification) {
            this.notify(AlertType.Warning, message, keepAfterRouteChange, removedAfter);
        } else {
            this.alert(AlertType.Warning, message, keepAfterRouteChange, removedAfter);
        }
    }

    publish(message: string, notification = false, keepAfterRouteChange = false, removedAfter = 6000) {
        if (notification) {
            this.notify(AlertType.Publish, message, keepAfterRouteChange, removedAfter);
        } else {
            this.alert(AlertType.Publish, message, keepAfterRouteChange, removedAfter);
        }
    }

    unpublish(message: string, notification = false, keepAfterRouteChange = false, removedAfter = 6000) {
        if (notification) {
            this.notify(AlertType.Unpublish, message, keepAfterRouteChange, removedAfter);
        } else {
            this.alert(AlertType.Unpublish, message, keepAfterRouteChange, removedAfter);
        }
    }

    alert(type: AlertType, message: string, keepAfterRouteChange = false, removedAfter = 6000) {
        this.keepAfterRouteChange = keepAfterRouteChange;
        this.subject.next(<Alert>{ type: type, message: message, removedAfter: removedAfter });
    }

    clear() {
        // clear alerts
        this.subject.next();
    }

    emitLogoEvent() {
        this.logoEvent.emit('reload logo');
    }


    notify(type: AlertType, message: string, keepAfterRouteChange = false, removedAfter = 6000) {
        this.keepAfterRouteChange = keepAfterRouteChange;
        this.notif.next(<Alert>{ type: type, message: message, removedAfter: removedAfter });
    }

    clearNotif() {
        // clear alerts
        this.notif.next();
    }
}
